import * as classnames from 'classnames'
import get from 'lodash-es/get'
import * as React from 'react'
import { RouterAction } from 'react-router-redux'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { getFlattenLocation } from '../../../../common/utils/urlHelper'
import { getConfigBySite } from '../../../../config/sites'
import { IStudioRecommendations } from '../../../../typings/studioRecommendations'
import ElementsBanner from '../../../shared/components/elementsBanner'
import LoadingSpinner from '../../../shared/components/icons/loadingSpinner'
import LayoutSwitcher from '../../../shared/components/layoutSwitcher'
import UsDollarsNoticeContainer from '../../../shared/components/usDollarsNotice/usDollarsNoticeContainer'
import FeatureContainer from '../../../shared/containers/feature'
import RelatedSearches from '../../../v0/pages/search/result/relatedSearches'
import V0SearchResults from '../../../v0/pages/search/result/searchResultBody'
import Pagination from '../../../v1/components/pagination/pagination'
import ToggleFilterButton from '../../components/filters/filterGroup/toggleButtonContainer'
import SearchFiltersContainer from '../../components/filters/searchFiltersContainer'
import SelectedFilters from '../../components/filters/selectedFilters'
import SortByDropdown from '../../components/sortBy/sortBy'
import SearchNoResults from './result/searchNoResults'
import SearchResults from './result/searchResults'

import { Site } from '../../../../common/constants/siteList'
import { ISearchResults } from '../../../../typings/searchResults'
import * as hostedStyles from './hostedSearch.module.css'
import * as styles from './searchContentSection.module.css'

interface IProps {
  searchResultsViewType: string
  baseUrl: string
  results: ISearchResults
  location: any
  loading: boolean
  currentSite: Site
  relatedSearches?: any
  push: (path: string) => RouterAction
  experiments: any
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

class SearchContentSection extends React.Component<IProps> {
  public render() {
    const {
      searchResultsViewType,
      baseUrl,
      results,
      location,
      loading,
      currentSite,
      relatedSearches,
      push,
      experiments,
      locationParams,
      makeSearchLink
    } = this.props

    const totalHits = results.total_hits
    const aggregations = get(results, 'aggregations')
    const didYouMeanByTerms = get(results, 'suggestions', [])
    const flattenLocation = getFlattenLocation(location)
    const matches = results.matches
    const haveResults = !!(matches && matches.length)
    const shouldShowRecommendedSearches =
      !loading && relatedSearches && relatedSearches.recommendations.length > 0
    const pageSize = getConfigBySite(currentSite, 'common.search_page_size')
    const maxPagesCount = getConfigBySite(currentSite, 'common.max_pages_count')

    const shouldShowPromotionBanner =
      haveResults && currentSite === Site.themeforest

    const SearchResultsComponent = (
      <div>
        <FeatureContainer name="!transition-to-new-design">
          <SearchResults
            baseUrl={baseUrl}
            results={results}
            location={location}
            currentSite={currentSite}
            locationParams={locationParams}
            makeSearchLink={makeSearchLink}
          />
        </FeatureContainer>
        <FeatureContainer name="transition-to-new-design">
          <V0SearchResults location={location} matches={results.matches} />
          <Pagination
            currentPage={Number(location.query.page) || 1}
            currentSite={currentSite}
            totalItemsCount={totalHits}
            pageSize={pageSize}
            locationParams={locationParams}
            makeSearchLink={makeSearchLink}
            baseUrl={baseUrl}
            maxPagesCount={maxPagesCount}
          />
        </FeatureContainer>
      </div>
    )

    const resultsContainer = haveResults ? (
      SearchResultsComponent
    ) : (
      <SearchNoResults
        locationParams={locationParams}
        didYouMeanByTerms={didYouMeanByTerms}
      />
    )

    const loadingContainer = (
      <div className={styles.loadingContainer}>
        <LoadingSpinner />
      </div>
    )

    const hostingSetupSelected = locationParams.hosting_setup === '1'

    const searchControlClass = hostingSetupSelected
      ? hostedStyles.searchControls
      : styles.searchControls

    return (
      <div className={styles.searchContentSection} id="content">
        <div className={searchControlClass}>
          <ToggleFilterButton id="filterGroup" />
          <div className={styles.searchResultHeader}>
            <div className={styles.headerRightSideContainer}>
              <UsDollarsNoticeContainer styleClassName={styles.gstMessage} />
              <div className={styles.headerRightSide}>
                <LayoutSwitcher
                  locationParams={locationParams}
                  currentSite={currentSite}
                  currentView={searchResultsViewType}
                  hideLayoutSwitchOnMobile
                />
                <SortByDropdown
                  push={push}
                  currentSite={currentSite}
                  locationParams={locationParams}
                  makeSearchLink={makeSearchLink}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.searchResults}>
          <SearchFiltersContainer
            totalHits={totalHits}
            currentSite={currentSite}
            aggregations={aggregations}
            locationParams={locationParams}
            makeSearchLink={makeSearchLink}
            loading={loading}
          />
          <div className={styles.searchResultsBody}>
            <SelectedFilters
              totalHits={totalHits}
              term={locationParams.term}
              loading={loading}
              locationParams={locationParams}
              currentSite={currentSite}
            />

            {loading ? loadingContainer : resultsContainer}
            {shouldShowRecommendedSearches && (
              <RelatedSearches {...relatedSearches} />
            )}
            {shouldShowPromotionBanner && (
              <ElementsBanner currentSite={currentSite} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default SearchContentSection
